import { ReactNode } from 'react';

interface ControlsProps {
  children: ReactNode;
}

export const Controls = ({ children }: ControlsProps) => {
  return <>{children}</>;
};
